// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resource-capacity[data-v-f8bb3704]{width:300px;padding-bottom:2px}`, "",{"version":3,"sources":["webpack://./src/components/Editor/Resources/ResourceSeatingCapacity.vue"],"names":[],"mappings":"AACA,oCACC,WAAA,CACA,kBAAA","sourcesContent":[".resource-capacity{width:300px;padding-bottom:2px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
